import { Component, OnInit, Input, Inject, ElementRef, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-blocco-solo-testo',
  templateUrl: './blocco-solo-testo.component.html',
  styles: []
})
export class BloccoSoloTestoComponent implements OnInit, AfterViewInit {

  constructor(@Inject(DOCUMENT) private document: any, private route: ActivatedRoute) { }

  @Input() campi;
  @Input() painted = false;

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.route.fragment.subscribe((fragment: string) => {
      this.scrollTo(fragment);
    });
  }

  scrollTo(arg) {
    const element = document.getElementById(arg);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

